const closeapprove = {
  path: 'closeapprove',
  component: resolve => require(['@/pages/admin/closeapprove'], resolve),
  meta: {
    requireAuth: true
  }
}

export default closeapprove
